import { useMemo } from 'react';
import { useAbility } from '@/modules/identity/application/ability';

type PermissionAction = 'create' | 'read' | 'update' | 'delete' | 'manage';

export const useCurrentRoleSubjectPermission = (subject: string) => {
  const ability = useAbility();

  return useMemo(() => {
    const can = (action: PermissionAction) =>
      ability.can('manage', 'all') ||
      ability.can('manage', subject) ||
      ability.can(action, subject);

    return {
      canCreate: can('create'),
      canRead: can('read'),
      canUpdate: can('update'),
      canDelete: can('delete'),
      canManage: can('manage'),
    };
  }, [ability, subject]);
};
